import React, { useEffect, useState } from 'react'

import Axios from 'axios'

import TeamUpcomingFixtures from './TeamUpcomingFixtures'
import FixtureTemplate from '../Fixture/FixtureTemplates/FixtureTemplate'

function TeamFixtures(props) {
    const [teamFixtures, setTeamFixtures] = useState()
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        async function fetchTeamFixtures() {
            setIsLoading(true)

            try {
                const response = await Axios({
                    method: 'GET',
                    url:
                        'https://api-football-v1.p.rapidapi.com/v2/fixtures/team/' +
                        props.id +
                        '/last/10',
                    headers: {
                        'content-type': 'application/octet-stream',
                        'x-rapidapi-host': 'api-football-v1.p.rapidapi.com',
                        'x-rapidapi-key':
                            '4a924e26e2msh6cbbda7a5553cb0p10cffcjsn999d1a4b9b45',
                        useQueryString: true,
                    },
                    params: {
                        timezone: 'Europe/London',
                    },
                })
                console.log(response.data.api.fixtures[0])
                setTeamFixtures(response.data.api.fixtures)
            } catch (error) {
                console.log(error)
            }
            setIsLoading(false)
        }
        fetchTeamFixtures()
    }, [props.id])

    if (isLoading) return <p>LAster...</p>

    return (
        <div>
            {teamFixtures?.map((fixture, index) => {
                return (
                    <FixtureTemplate
                        key={index}
                        fixture={fixture}
                        type="small"
                    />
                )
            })}

            <div>
                <TeamUpcomingFixtures id={props.id} type="small" />
            </div>
        </div>
    )
}
export default TeamFixtures
